import { useEffect } from "react";

export default function usePreventSwipe() {
  const preventSwipe = (ev) => {
    console.log(ev);
    ev.stopPropagation();
    ev.preventDefault();
  };

  useEffect(() => {
    const options = { passive: false };
    document.addEventListener("touchmove", preventSwipe, options);

    return () => {
      document.removeEventListener("touchmove", preventSwipe, options);
    };
  }, []);
}
